import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import { useRemoteConfigStore } from '@/shared/firebase';
import type { RemoteConfigKey } from '@/shared/firebase/types/remoteConfig.types';
import { REMOTE_CONFIG_TYPED_DEFAULTS } from '@/shared/firebase/constants/remoteConfig.constant';
import { resolveRouteFeatureFlagAllowed } from '@/shared/firebase/utils/resolveRouteFeatureFlagAllowed.util';

export const validateFirebaseFeatureFlags = (
  to: RouteLocationNormalized,
  _from?: RouteLocationNormalized
): boolean | RouteLocationRaw | string | void => {
  if (!to.meta?.flag) {
    return true;
  }

  const flagName = String(to.meta.flag);

  if (!(flagName in REMOTE_CONFIG_TYPED_DEFAULTS)) {
    return true;
  }

  const remoteConfigStore = useRemoteConfigStore();
  const flagKey = typeof to.meta.flagKey === 'string' ? to.meta.flagKey : null;

  const isAllowed = resolveRouteFeatureFlagAllowed(
    remoteConfigStore,
    flagName as RemoteConfigKey,
    flagKey
  );

  if (!isAllowed) {
    return { name: 'movements' };
  }

  return true;
};
